import { createFileRoute } from '@tanstack/react-router';

import { CreateDestinationContainer } from '@/features/destinations/containers/create';

export const Route = createFileRoute('/_layout/destinations/create')({
  component: CreateDestinationContainer,
});
